import type { Ref } from 'react';
import { forwardRef } from 'react';

import type { TIconSize } from '../icon.interface';

const EmailBillingIcon = forwardRef(
  ({ ...props }: TIconSize, ref: Ref<SVGSVGElement>) => {
    return (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={ref}
        {...props}
      >
        <path
          d="M1.75 8.25C1.75 5.18587 1.75 3.65381 2.7019 2.7019C3.65381 1.75 5.18587 1.75 8.25 1.75H23.75C26.8141 1.75 28.3462 1.75 29.2981 2.7019C30.25 3.65381 30.25 5.18587 30.25 8.25V15.75C30.25 18.8141 30.25 20.3462 29.2981 21.2981C28.3462 22.25 26.8141 22.25 23.75 22.25H8.25C5.18587 22.25 3.65381 22.25 2.7019 21.2981C1.75 20.3462 1.75 18.8141 1.75 15.75V8.25Z"
          fill="#E4E0FF"
        />
        <path
          d="M2.5 2.5L13.7919 12.9555C15.0379 14.1092 16.9621 14.1092 18.2081 12.9555L29.5 2.5L28 2H4L2.5 2.5Z"
          fill="white"
        />
        <path
          d="M3.26063 3.20435L13.7919 12.9555C15.0379 14.1092 16.9621 14.1092 18.2081 12.9555L28.7392 3.20453C28.7487 3.21368 28.7582 3.22294 28.7676 3.23229C28.9407 3.40545 29.0789 3.61615 29.186 3.90531L19.9586 14.4998C17.8661 16.9023 14.1333 16.9023 12.0407 14.4998L2.81348 3.90554C2.92065 3.61626 3.05883 3.40549 3.23204 3.23229C3.24145 3.22287 3.25098 3.21356 3.26063 3.20435Z"
          fill="#C0AAFE"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.8053 1H8.19466C6.7096 0.999982 5.51895 0.999967 4.58393 1.12568C3.61575 1.25585 2.8101 1.53305 2.17157 2.17157C1.53305 2.8101 1.25585 3.61575 1.12568 4.58393C0.999967 5.51895 0.999982 6.70958 1 8.19465V15.8053C0.999982 17.2904 0.999967 18.481 1.12568 19.4161C1.25585 20.3843 1.53305 21.1899 2.17157 21.8284C2.8101 22.467 3.61575 22.7442 4.58393 22.8743C5.51896 23 6.7096 23 8.19467 23H23.8053C25.2904 23 26.481 23 27.4161 22.8743C28.3843 22.7442 29.1899 22.467 29.8284 21.8284C30.467 21.1899 30.7442 20.3843 30.8743 19.4161C31 18.481 31 17.2904 31 15.8053V8.19466C31 6.7096 31 5.51896 30.8743 4.58393C30.7442 3.61575 30.467 2.8101 29.8284 2.17157C29.1899 1.53305 28.3843 1.25585 27.4161 1.12568C26.481 0.999967 25.2904 0.999982 23.8053 1ZM3.932 2.80402C4.16108 2.72199 4.43857 2.65872 4.7838 2.6123C5.60723 2.50159 6.69673 2.5 8.25 2.5H23.75C25.3033 2.5 26.3928 2.50159 27.2162 2.6123C27.5613 2.6587 27.8387 2.72194 28.0677 2.80391L17.6983 12.4052C16.7398 13.2927 15.2597 13.2927 14.3013 12.4052L3.932 2.80402ZM2.8401 3.83727C2.74031 4.08363 2.66531 4.38953 2.6123 4.7838C2.50159 5.60723 2.5 6.69673 2.5 8.25V15.75C2.5 17.3033 2.50159 18.3928 2.6123 19.2162C2.72011 20.0181 2.91886 20.4544 3.23223 20.7678C3.54561 21.0811 3.98195 21.2799 4.7838 21.3877C5.60723 21.4984 6.69673 21.5 8.25 21.5H23.75C25.3033 21.5 26.3928 21.4984 27.2162 21.3877C28.0181 21.2799 28.4544 21.0811 28.7678 20.7678C29.0811 20.4544 29.2799 20.0181 29.3877 19.2162C29.4984 18.3928 29.5 17.3033 29.5 15.75V8.25C29.5 6.69673 29.4984 5.60723 29.3877 4.7838C29.3347 4.38938 29.2596 4.0834 29.1598 3.83698L18.7174 13.5058C17.1839 14.9258 14.8157 14.9258 13.2822 13.5058L2.8401 3.83727Z"
          fill="#0F3893"
        />
        <path
          d="M30.9531 15.5112C31.0552 15.2363 30.9877 14.9271 30.7803 14.7197C30.573 14.5123 30.2638 14.4448 29.9889 14.547L14.9889 20.1184C14.703 20.2246 14.5099 20.4933 14.5004 20.7981C14.4909 21.1029 14.6669 21.3832 14.9456 21.5069L21.2111 24.2889L23.9931 30.5544C24.1169 30.8331 24.3971 31.0091 24.7019 30.9997C25.0067 30.9902 25.2755 30.7971 25.3816 30.5112L30.9531 15.5112Z"
          fill="#006DFF"
        />
        <path
          d="M27.4418 18.9473C27.6858 18.7032 27.6858 18.3075 27.4418 18.0634C27.1977 17.8194 26.802 17.8194 26.5579 18.0634L20.6025 24.0188L21.211 24.289L21.4844 24.9047L27.4418 18.9473Z"
          fill="white"
        />
      </svg>
    );
  }
);
export default EmailBillingIcon;
